export default "data:image/gif;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiaW1hZ2VzL2J4X2xvYWRlci5naWYiOw=="